export default {
    state: {
        menuRestaurants: [],
        currentRestaurant: {},
        restaurantGroups: []
    },
    mutations: {
        setMenuRestaurants (state, menuRestaurants) {
            state.menuRestaurants = menuRestaurants
        },
        setCurrentRestaurant (state, restaurant) {
            state.currentRestaurant = restaurant
        },
        setMenuGroups (state, groups) {
            state.restaurantGroups = groups
        }
    },
    actions: {
        setMenuRestaurants ({ commit }, menuRestaurants) {
            commit('setMenuRestaurants', menuRestaurants)
        },
        setCurrentRestaurant ({ commit }, restaurant) {
            commit('setCurrentRestaurant', restaurant)
        },
        setMenuGroups ({ commit }, groups) {
            commit('setMenuGroups', groups)
        }
    },
    getters: {
        menuRestaurants: (state) => state.menuRestaurants,
        currentRestaurant: (state) => state.currentRestaurant,
        restaurantGroups: (state) => state.restaurantGroups
    }
}
